import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NoconnectionComponent } from './noconnection.component';

const routes: Routes = [{ path: '', component: NoconnectionComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NoconnectionRoutingModule {}
